import { useEffect, useState } from "react";
import styled from "styled-components";
import {
  getSchoolDocDetail,
  getSchoolDocList,
  SchoolDoc,
  SchoolDocDetail,
} from "api/SchoolDocsAPI";
import { getSchoolInfo } from "api/UserAPI";
import { validSubdomain } from "utils";
import { Item } from "./styledComponents";

const Container = styled.div``;

const Message = styled.div`
  margin-top: 16px;
  font-size: ${(props) => props.theme.fontSizes.subtitle1FontSize};
  color: ${(props) => props.theme.colors.secondaryGrey};
`;

const DocumentsList = () => {
  const [docs, setDocs] = useState<SchoolDoc[]>([]);
  const [loading, setLoading] = useState(true);
  const [expandedId, setExpandedId] = useState<string | null>(null);
  const [loadingId, setLoadingId] = useState<string | null>(null);
  const [details, setDetails] = useState<Record<string, SchoolDocDetail>>({});

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const school = await getSchoolInfo(validSubdomain);
        const resp = await getSchoolDocList(school.data.id);
        if (!cancelled) setDocs(resp.data ?? []);
      } catch (e) {
        console.log(e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, []);

  const handleToggle = async (doc: SchoolDoc) => {
    if (expandedId === doc.id) {
      setExpandedId(null);
      return;
    }

    if (details[doc.id]) {
      setExpandedId(doc.id);
      return;
    }

    setLoadingId(doc.id);
    try {
      const resp = await getSchoolDocDetail(doc.id);
      setDetails((prev) => ({ ...prev, [doc.id]: resp.data }));
      setExpandedId(doc.id);
    } catch (e) {
      console.log(e);
    } finally {
      setLoadingId(null);
    }
  };

  if (loading) return <Message>Загрузка документов…</Message>;

  // Раздел показывается только тем школам, у которых есть документы
  if (!docs.length) return null;

  return (
    <Container>
      {docs.map((doc) => (
        <Item
          key={doc.id}
          name={doc.name}
          expanded={expandedId === doc.id}
          loading={loadingId === doc.id}
          content={details[doc.id]?.content}
          onToggle={() => handleToggle(doc)}
        />
      ))}
    </Container>
  );
};

export default DocumentsList;
